// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__1kaal","search":"Settings_search__27_P5","filter":"Settings_filter__1v51E"};